import { FilterDescriptor } from '@progress/kendo-data-query'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

interface NotificationPlatformTypeFilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const NotificationPlatformTypeFilter: React.FC<NotificationPlatformTypeFilterProps> = (
  props
) => {
  const { filter, onFilterChange } = props
  const notificationTypes = useAppSelector((state) => state.clientArea.notificationPlatforms)

  const data = notificationTypes.map((x) => ({ id: x.id, label: x.name, value: x.id }))

  return (
    <SelectFilter
      placeholder='Notification Platrorm Type'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
      style={{ width: 240 }}
    />
  )
}
